import * as React from "react";

const CENWrench: React.FC = () => {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M41.6657 14.6025C41.4615 13.7524 40.3825 13.4683 39.7645 14.0865L34.382 19.4696L28.5391 19.4696V13.6266L33.9215 8.24352C34.5396 7.62555 34.2555 6.54618 33.4057 6.34227C31.74 5.94198 29.9365 5.91259 28.0675 6.35974C23.7468 7.39333 20.3754 11.0636 19.6863 15.4511C19.3204 17.2743 19.4962 19.0954 20.0446 20.7407L7.52195 33.2634C5.54477 35.2406 5.54477 38.4447 7.52195 40.4212C8.44727 41.4126 9.74102 41.9681 10.9743 41.9681C12.2076 41.9681 13.5646 41.4737 14.5539 40.4852L27.0766 27.9625C28.7261 28.5065 30.5437 28.6825 32.4323 28.3847C36.8205 27.6928 40.4901 24.3206 41.5237 20.0034C42.0946 18.0689 42.0665 16.2689 41.6657 14.6025ZM11.6001 38.0306C10.6684 38.0306 9.91258 37.2747 9.91258 36.3431C9.91258 35.4107 10.6684 34.6556 11.6001 34.6556C12.5317 34.6556 13.2876 35.4107 13.2876 36.3431C13.2876 37.2782 12.5317 38.0306 11.6001 38.0306Z"
                fill="#BDBBBD"
            />
        </svg>
    );
};

export default React.memo(CENWrench);
